import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Link from '../../links/Link/Link';
import ShareButton from '../../buttons/ShareButton/ShareButton';

/**
 * A component for displaying additional page utilities
 */
function UtilityButtons({ xHref, facebookHref, shareEmailAddress, backToTopHref }) {
  const { t } = useTranslation();

  return (
    <div className="footer__content">
      <div className="content__sharebar">
        <div className="sharebar__content">
          <div className="content__wrapper">
            <ShareButton xHref={xHref} facebookHref={facebookHref} shareEmailAddress={shareEmailAddress} />
            <a href={backToTopHref} className="button button--icon icon--left icon--scroll-up content__back-to-top">
              {t('styleguide:back_to_top')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

UtilityButtons.propTypes = {
  /**
   * The X link
   */
  xHref: PropTypes.string,
  /**
   * The Facebook link
   */
  facebookHref: PropTypes.string,
  /**
   * The share email address
   */
  shareEmailAddress: PropTypes.string,
  /**
   * The back to top handler
   */
  onBackToTopPress: PropTypes.func
};

export default UtilityButtons;
